
import {typesCruisefare} from './svtypes/cruisefareTypes'
import {SV_SOJ_ORCMOCK_ADDRESS} from '../constants'
const _ = require('lodash')
const HBD_URL = 'http://photos.hotelbeds.com/giata/'
  

let initStore = {
    loading: false,
    error: false,
    fgtree :{
        "10": {
            "facilityGroupCodeName": "Location",
            "facilityGroupCode": 10,
            "facilities": [
                {
                    "id": 12,
                    "code": 100,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Suites"
                },
                {
                    "id": 30,
                    "code": 110,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Apartments"
                },
                {
                    "id": 53,
                    "code": 124,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Disability-friendly rooms"
                },
                {
                    "id": 109,
                    "code": 20,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Year of construction"
                },
                {
                    "id": 224,
                    "code": 30,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Year of most recent renovation"
                },
                {
                    "id": 315,
                    "code": 40,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Annexe (s)"
                },
                {
                    "id": 358,
                    "code": 50,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Number of floors (main building)"
                },
                {
                    "id": 447,
                    "code": 60,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Number of floors (annexe)"
                },
                {
                    "id": 493,
                    "code": 70,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 20,
                    "description": "Total number of rooms"
                },
                {
                    "id": 533,
                    "code": 80,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Single rooms"
                },
                {
                    "id": 576,
                    "code": 90,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Double rooms"
                },
                {
                    "id": 589,
                    "code": 95,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Junior suites"
                }
            ]
        }
    },
     //sjjul3 commented
   // my_data: [],
    svr_cruise_detail_images_ob:{
        "images":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj7.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj8.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj9.jpg`],
        "gallery":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg` ],
        "arcade":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`],
        "face":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`]
    
    },
    excursions:[],
   
    //sjjul3 start
    my_esqueryText : "mexco",
    svcli_esquery_data : {
       
       
       
        escountryOrg:"LAX",
        escountryDst:"A",
        my_orgqueryText: "xx",
        my_dstqueryText: "yy",
        STARTDATE:"2025-11-25",
        ENDDATE: "2025-11-27",
        DT_FORMAT: "%Y-%m-%d",
        time_zone: "Asia/Kolkata",


        esqueryChilds:"m0",
        esqueryInfants:"i0",
        esqueryAdults:"t1",
        esquerySpecials:"J",
        esqueryTripType:"roundtrip",
        esqueryPortcall : "LAX",
        esqueryShip : "AQ",
        esqueryDur : "D1",
        svpageSize:5
         /*arilines end */

    },
    hasMore:true,
    ctotal:3,
    my_scr_id:"AAluY2x1ZGVfY29udGV4dF91dWlkDXF1ZXJ5QW5kRmV0Y2gBFkpsWjEtSjJpU0VlUnFWRFRUcDZrMlEAAAAAAAATQRZqU0xtQ3VBQ1NPZWNXbGI5NEx6TVdR",
    my_data: [
        {
            "averageGuestBrochurePrice": 4029.0,
            "averageGuestPrice": 4029.0,
            "catid": 4,
            "catname": "SUITE",
            "code": "S",
            "guests": [
                {
                    "baseFare": 4029.0,
                    "brochureFare": 4029.0,
                    "fare": 4029.0,
                    "id": 0,
                    "noTfpe": "N"
                },
                {
                    "baseFare": 4029.0,
                    "brochureFare": 4029.0,
                    "fare": 4029.0,
                    "id": 1,
                    "noTfpe": "N"
                },
                {
                    "baseFare": 4029.0,
                    "brochureFare": 4029.0,
                    "fare": 4029.0,
                    "id": 2,
                    "noTfpe": "N"
                },
                {
                    "baseFare": 4029.0,
                    "brochureFare": 4029.0,
                    "fare": 4029.0,
                    "id": 3,
                    "noTfpe": "N"
                },
                {
                    "baseFare": 4029.0,
                    "brochureFare": 4029.0,
                    "fare": 4029.0,
                    "id": 4,
                    "noTfpe": "N"
                }
            ],
            "idBrandCode": "S6",
            "igvtIncluded": "Y",
            "includedPromos": null,
            "label": " SUITE",
            "priceTimeExId": 1934,
            "promo": null,
            "rcfeIncluded": "Y",
            "srid": 233,
            "status": null,
            "svcNoRefFlag": null,
            "svcavailability": null,
            "svcavailableCabins": null
        },
        {
            "averageGuestBrochurePrice": 1479.0,
            "averageGuestPrice": 1479.0,
            "catid": 9,
            "catname": "MINI SUITE",
            "code": "M",
            "guests": [
                {
                    "baseFare": 1479.0,
                    "brochureFare": 1479.0,
                    "fare": 1479.0,
                    "id": 0,
                    "noTfpe": "N"
                },
                {
                    "baseFare": 1479.0,
                    "brochureFare": 1479.0,
                    "fare": 1479.0,
                    "id": 1,
                    "noTfpe": "N"
                },
                {
                    "baseFare": 1479.0,
                    "brochureFare": 1479.0,
                    "fare": 1479.0,
                    "id": 2,
                    "noTfpe": "N"
                },
                {
                    "baseFare": 1479.0,
                    "brochureFare": 1479.0,
                    "fare": 1479.0,
                    "id": 3,
                    "noTfpe": "N"
                },
                {
                    "baseFare": 1479.0,
                    "brochureFare": 1479.0,
                    "fare": 1479.0,
                    "id": 4,
                    "noTfpe": "N"
                }
            ],
            "idBrandCode": "MF",
            "igvtIncluded": "Y",
            "includedPromos": null,
            "label": "MINI SUITE",
            "priceTimeExId": 1934,
            "promo": null,
            "rcfeIncluded": "Y",
            "srid": 234,
            "status": null,
            "svcNoRefFlag": null,
            "svcavailability": null,
            "svcavailableCabins": null
        },
        {
            "averageGuestBrochurePrice": 1074.0,
            "averageGuestPrice": 1074.0,
            "catid": 3,
            "catname": "BALCONY",
            "code": "B",
            "guests": [
                {
                    "baseFare": 1074.0,
                    "brochureFare": 1074.0,
                    "fare": 1074.0,
                    "id": 0,
                    "noTfpe": "N"
                },
                {
                    "baseFare": 1074.0,
                    "brochureFare": 1074.0,
                    "fare": 1074.0,
                    "id": 1,
                    "noTfpe": "N"
                },
                {
                    "baseFare": 1074.0,
                    "brochureFare": 1074.0,
                    "fare": 1074.0,
                    "id": 2,
                    "noTfpe": "N"
                },
                {
                    "baseFare": 1074.0,
                    "brochureFare": 1074.0,
                    "fare": 1074.0,
                    "id": 3,
                    "noTfpe": "N"
                },
                {
                    "baseFare": 1074.0,
                    "brochureFare": 1074.0,
                    "fare": 1074.0,
                    "id": 4,
                    "noTfpe": "N"
                }
            ],
            "idBrandCode": "BE",
            "igvtIncluded": "Y",
            "includedPromos": null,
            "label": "DELUXE BALCONY",
            "priceTimeExId": 1934,
            "promo": null,
            "rcfeIncluded": "Y",
            "srid": 235,
            "status": null,
            "svcNoRefFlag": null,
            "svcavailability": null,
            "svcavailableCabins": null
        },
        {
            "averageGuestBrochurePrice": 874.0,
            "averageGuestPrice": 874.0,
            "catid": 2,
            "catname": "OCEAN VIEW",
            "code": "O",
            "guests": [
                {
                    "baseFare": 874.0,
                    "brochureFare": 874.0,
                    "fare": 874.0,
                    "id": 0,
                    "noTfpe": "N"
                },
                {
                    "baseFare": 874.0,
                    "brochureFare": 874.0,
                    "fare": 874.0,
                    "id": 1,
                    "noTfpe": "N"
                },
                {
                    "baseFare": 874.0,
                    "brochureFare": 874.0,
                    "fare": 874.0,
                    "id": 2,
                    "noTfpe": "N"
                },
                {
                    "baseFare": 874.0,
                    "brochureFare": 874.0,
                    "fare": 874.0,
                    "id": 3,
                    "noTfpe": "N"
                },
                {
                    "baseFare": 874.0,
                    "brochureFare": 874.0,
                    "fare": 874.0,
                    "id": 4,
                    "noTfpe": "N"
                }
            ],
            "idBrandCode": "O6",
            "igvtIncluded": "Y",
            "includedPromos": null,
            "label": "OCEAN VIEW",
            "priceTimeExId": 1934,
            "promo": null,
            "rcfeIncluded": "Y",
            "srid": 236,
            "status": null,
            "svcNoRefFlag": null,
            "svcavailability": null,
            "svcavailableCabins": null
        },
        {
            "averageGuestBrochurePrice": 744.0,
            "averageGuestPrice": 744.0,
            "catid": 1,
            "catname": "INTERIOR",
            "code": "I",
            "guests": [
                {
                    "baseFare": 744.0,
                    "brochureFare": 744.0,
                    "fare": 744.0,
                    "id": 0,
                    "noTfpe": "N"
                },
                {
                    "baseFare": 744.0,
                    "brochureFare": 744.0,
                    "fare": 744.0,
                    "id": 1,
                    "noTfpe": "N"
                },
                {
                    "baseFare": 744.0,
                    "brochureFare": 744.0,
                    "fare": 744.0,
                    "id": 2,
                    "noTfpe": "N"
                },
                {
                    "baseFare": 744.0,
                    "brochureFare": 744.0,
                    "fare": 744.0,
                    "id": 3,
                    "noTfpe": "N"
                },
                {
                    "baseFare": 744.0,
                    "brochureFare": 744.0,
                    "fare": 744.0,
                    "id": 4,
                    "noTfpe": "N"
                }
            ],
            "idBrandCode": "IF",
            "igvtIncluded": "Y",
            "includedPromos": null,
            "label": "INTERIOR",
            "priceTimeExId": 1934,
            "promo": null,
            "rcfeIncluded": "Y",
            "srid": 237,
            "status": null,
            "svcNoRefFlag": null,
            "svcavailability": null,
            "svcavailableCabins": null
        }
    ],
    svr_soj_images : []
    
}

export default (state = initStore, action) => {
    
    let januState;
    switch (action.type) {
       
        case 'GET_CRUISEFARE_SUCCESS':
            
            if(action.payload.my_images){
                januState = {...state, loading: false, my_data: action.payload.my_data, svr_soj_detail_images_ob: action.payload.my_images}
            }else{
                januState = {...state, loading: false, my_data: action.payload.my_data}
            }
             
            return januState
     
        case 'GET_CRUISEFARE_BEGIN':
            
            return {...state, loading: true}
        case 'GET_CRUISEFARE_ERROR':
           
            return {...state, error: true}
        default:
            return state
    }
}